import ChangeLogData from 'src/data/changelogs.json'

export namespace ChangeLog {
  export function list(limit: number, offset: number) {
    const totalCount = ChangeLogData.length
    const items = ChangeLogData.sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))
      .filter((item) => item.isPublished)
      .slice(offset, offset + limit)
    return [totalCount, items] as [number, typeof ChangeLogData]
  }

  export function getById(id: string) {
    const item = ChangeLogData.find((item) => item._id === id)
    return item || null
  }
}
